<div>
	<button (click)="callHTTPTest()">Call HTTPTest</button>
</div>
